export default "__VITE_ASSET__CjGga7Q9__"